import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

const ConfirmDelete = ({ item, message = <div>Confirm ?</div>, onEvent }) => {
	const [show, setShow] = useState(false);
	useEffect(() => {
		setShow(item ? true : false);
	}, [item]);

	const handleEvent = (yes = true) => {
		onEvent(yes);
		setShow(false);
	};

	return (
		<Modal show={show} onHide={() => handleEvent(false)}>
			<Modal.Body>{message}</Modal.Body>
			<Modal.Footer>
				<button className="btn btn-default" type="button" onClick={() => handleEvent(false)}>
					No
				</button>
				<button className="btn btn-primary" type="button" onClick={() => handleEvent(true)}>
					Yes
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default ConfirmDelete;
